import { selectTicketTypes } from "app/redux/selector";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBoardForm,
  selectDraftBoardForm,
} from "../../../components/Settings/redux/selector";
import {
  findDefaultBoardTicketType,
  findDefaultBoardTypeName,
} from "../../../helpers";
import { selectTicketFormDetail } from "../redux/selector";
import { ticketGroupsActions } from "../redux/slice";
import { useTicketCreateActions } from "../useTicketCreateActions";

export const useAddTicketLogic = (
  groupId: string,
  subGroupId?: string,
  scrollToTop?: () => void,
) => {
  const dispatch = useDispatch();
  const ticketTypes = useSelector(selectTicketTypes);
  const boardDraftForm = useSelector(selectDraftBoardForm);
  const boardForm = useSelector(selectBoardForm);
  const ticketGroup = useSelector(selectTicketFormDetail);
  const { applyGroupValueToBoardForm, setTicketField } =
    useTicketCreateActions();

  const defaultType = useMemo(() => {
    return findDefaultBoardTicketType(
      ticketTypes || [],
      boardDraftForm.defaultTicketType,
    );
  }, [ticketTypes, boardDraftForm.defaultTicketType]);

  const defaultTypeName = useMemo(() => {
    return findDefaultBoardTypeName(
      ticketTypes || [],
      boardForm.defaultTicketType,
    );
  }, [ticketTypes, boardForm.defaultTicketType]);

  const baseCreateLogic = useCallback(() => {
    dispatch(ticketGroupsActions.clearCreateTicket());
    setTicketField("groupId", groupId);
    applyGroupValueToBoardForm(groupId, subGroupId);
  }, [dispatch, groupId, applyGroupValueToBoardForm]);

  const openTicketForm = useCallback(() => {
    dispatch(
      ticketGroupsActions.toggleCreateTicketIntoGroup({
        groupId,
        actions: true,
        subGroupId,
      }),
    );
  }, [groupId, subGroupId]);

  const handleTicketTask = useCallback(() => {
    baseCreateLogic();
    setTicketField("type", defaultType);

    openTicketForm();
    scrollToTop?.();
  }, [baseCreateLogic, defaultType, groupId]);

  const handleTicketType = useCallback(
    (value: string) => {
      baseCreateLogic();
      setTicketField("type", value);
      openTicketForm();
      scrollToTop?.();
    },
    [baseCreateLogic],
  );

  return {
    defaultTypeName,
    handleTicketTask,
    handleTicketType,
    selectedType: ticketGroup.type,
  };
};
